/**
 * The states of Hulk's wishlist page (/apps/favoritos), as classes.
 *
 * Hulk shows its «inicia sesión» and «lista vacía» messages, and the links of
 * the title, with an inline `display`. assets/mm-tokens.css, section 45, used
 * to read those inline styles itself, with `:has()` around `[style]`
 * selectors -- and one such selector in the page's CSS makes every inline
 * style change on every page restyle the whole document (section 50 there).
 * This file reads them instead and keeps three classes up to date:
 *
 * - `.mm-wishlist--message` on `.hulk__wishlist-wrap`, while either message
 *   is displayed
 * - `.mm-wishlist__links--shown` on each group of title links with one shown
 * - `.mm-wishlist__title--links` on a title with such a group
 *
 * Loaded by snippets/mm-header-wishlist.liquid on the wishlist page only.
 * Depends on Hulk's `.hulk__wishlist-wrap`, `.wishlist-login`,
 * `.wishlist-empty` and `.fancy_title` (docs/overrides.md, third parties).
 * If they change, or this file fails to load, the classes are never set and
 * the page keeps Hulk's own spacing for those two messages.
 */

/**
 * The same test the stylesheet made with `[style*='…']`.
 * @param {Element} element
 * @param {string} value
 */
const styled = (element, value) => (element.getAttribute('style') ?? '').includes(value);

function sync() {
  for (const wrap of document.querySelectorAll('.hulk__wishlist-wrap')) {
    const message = [...wrap.querySelectorAll('.wishlist-login, .wishlist-empty')].some((element) =>
      styled(element, 'block')
    );
    wrap.classList.toggle('mm-wishlist--message', message);

    for (const title of wrap.querySelectorAll('.fancy_title')) {
      let links = false;

      for (const group of title.querySelectorAll(':scope > div')) {
        const shown = [...group.querySelectorAll('a')].some((link) => styled(link, 'inline'));
        group.classList.toggle('mm-wishlist__links--shown', shown);
        links ||= shown;
      }

      title.classList.toggle('mm-wishlist__title--links', links);
    }
  }
}

// Hulk builds the page after load and switches the states later; a class
// toggled to the value it already has is no mutation, so this settles.
new MutationObserver(sync).observe(document.body, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['style'],
});

sync();
